import { createFileRoute } from '@tanstack/react-router';

import { AuthLayout } from '@/components/layouts/AuthLayout';
import { StaffAuthBrandPanel } from '@/components/layouts/components/StaffAuthBrandPanel';
import { InviteAcceptForm } from '@/features/auth/components/InviteAcceptForm';

export const Route = createFileRoute('/invite/accept')({
  component: InviteAcceptPage,
  validateSearch: (s: Record<string, unknown>) => ({
    token: typeof s.token === 'string' ? s.token : undefined,
  }),
});

function InviteAcceptPage() {
  return (
    <AuthLayout brandPanel={<StaffAuthBrandPanel />} formSide="left">
      <InviteAcceptForm />
    </AuthLayout>
  );
}
